import React from 'react'
import 'styles/trustedByBlock.scss'

const Block = ({ size = '4', iconName, heading }) => {
  return (
    <div className={`col-sm-${size} trustedByInnerWrap`}>
      <div className="trustedBlockwrap">
        <span className={`${iconName}`} />
        <span className="trustedText">{heading}</span>
      </div>
    </div>
  )
}

function TrustedByBlock(props) {
  return (
    <div className="col-sm-8 col-sm-offset-2 trustedByBlockWrap">
      <div className="trustedByButton">Trusted by Millions</div>
      <div className="row">
        <Block iconName="best_matches" heading="Best Matches" />
        <Block iconName="max_respones" heading="Verified Profiles" />
        <Block iconName="privacy" heading="100% Privacy" />
      </div>
    </div>
  )
}

export default TrustedByBlock
